<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                      <vs-button  @click="edit()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
                      <vs-button  @click="requestPassword()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-trash" icon-pack="feather" type="filled"></vs-button>
                      <h4>{{$t('Labels.Detail')}}</h4>
                      <table cellspancing="5" class="border-separate mt-5">
                        <tbody>
                          <tr>
                            <td class="text-center">
                              <vs-avatar :src="'data:image/jpeg;base64,'+response.image" size="120px" />
                            </td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Name')}}</td>
                            <td class=" px-2 py-1">{{response.name}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.ContactName')}}</td>
                            <td class=" px-2 py-1">{{response.contact_name}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Address')}}</td>
                            <td class=" px-2 py-1">{{response.address}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.PhoneNumber')}}</td>
                            <td class=" px-2 py-1">{{ response.phone_number | VMask('###-###-##-##') }}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.created_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
                            <td class=" px-2 py-1" v-if="response.user_creator">{{response.user_creator.first_name + ' ' + response.user_creator.last_name}}</td>
                          </tr>
                          <tr>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.UpdatedAt')}}</td>
                            <td class=" px-2 py-1">{{response.updated_at}}</td>
                            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Modifier')}}</td>
                            <td class=" px-2 py-1" v-if="response.user_update">{{response.user_update != null ? response.user_update.first_name + ' ' + response.user_update.last_name:''}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </vx-card>
                </div>
                
            </div>
            <div class="w-full">
              <vx-card class="grid-view-item mb-base overflow-hidden">
                  <h4>{{$t('Labels.Assignments')}}</h4>
                <table cellspancing="5" class="border-separate mt-5" v-if="response">
                  <tbody>
                    <tr>
                      <td class="bg-grey-light px-4 py-1 rounded ">{{$tc("Labels.License",2)}}</td>
                      <td class=" px-2 py-1">{{response.count_licenses}}</td>
                      <vs-button @click="goLicenses()" type="border">{{$t("Labels.GoTo") + ' ' + $tc("Labels.License",2)}}</vs-button>
                    </tr>
                  </tbody>
                </table>
              </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import valueItem from '@/components/valueItem/valueItem.vue'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  components: {
    valueItem,
    listItem
  },

  data () {
    return {
      response: [],
      uuid: this.$route.params.uuid
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `companies/${this.uuid}`,
        method: 'GET',
        params: {}
      }
      await request(params).then(response => {
        this.response = response.data.data
      })
    },
    edit () {
      window.location.href =  `/organizations/${this.uuid}/update`
    },
    requestPassword () {
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `companies/${this.uuid}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      })       
    },
    goLicenses () {
      window.location.href = `/licenses?company_uuid=${this.uuid}`
    }
  },
  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Companies')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.doDelete()
    }
  }
}
</script>
